import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { PlayTestAudienceDescriptions, PlayTestAudienceLabels, AudienceTypes } from "@seabrookstudios/pitch2table-core";
import CircularProgress from "@mui/material/CircularProgress";

const Label = "Play Test Audience";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestAudience|undefined} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").PlayTestAudience) => void} props.onChange
 * @param {boolean} [props.isPending]
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 */
export const AudienceSelect = ({ value, onChange, helperText, disabled = false, isPending = false }) => {
  /**
   * @param {*} ev
   */
  const onChangeHandler = (ev) => {
    onChange(ev.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal" disabled={disabled}>
      <InputLabel id="play-test-audience-label">{Label}</InputLabel>
      <Select
        labelId="play-test-audience-label"
        id="play-test-audience"
        value={value}
        onChange={onChangeHandler}
        placeholder={Label}
        label={Label}
        input={<OutlinedInput label={Label} />}
      >
        {isPending ? (
          <CircularProgress />
        ) : (
          AudienceTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {PlayTestAudienceLabels[type]} - {PlayTestAudienceDescriptions[type]}
            </MenuItem>
          ))
        )}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
